import { render } from "./AlarmBox.vue?vue&type=template&id=f0a9844c&scoped=true"
import script from "./AlarmBox.vue?vue&type=script&lang=js"
export * from "./AlarmBox.vue?vue&type=script&lang=js"

import "./AlarmBox.vue?vue&type=style&index=0&id=f0a9844c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0a9844c"]])

export default __exports__